module.exports = __webpack_public_path__ + "media/icons/question_marks-fa00ce98.svg";